"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var OrderStatusHeader_1 = require("../components/OrderStatus/OrderStatusHeader");
var targetNode = document.querySelector('.order-header-status-section');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(OrderStatusHeader_1.default, null), targetNode);
}
